import React from 'react';
import classNames from 'classnames';

const MobileProductFilterWrapper = ({ children, id, label }) => {
  const isQuickshipFilter = id === 'quickship';

  return (
    <div
      className={classNames(
        '[&:last-child]:border-0 [&:last-child]:mb-0 [&:last-child]:pb-0',
        {
          'border-b-[1px] border-gray-light7 mb-5 pb-5': !isQuickshipFilter,
          'border-0 mb-3 pb-0': isQuickshipFilter,
        }
      )}
      data-xc={`mobile-filter-section-${id ?? ''}`}
    >
      {!!label && !isQuickshipFilter && (
        <h3 className="mb-2 text-base font-bold text-gray">{label}</h3>
      )}

      {children}
    </div>
  );
};

export default MobileProductFilterWrapper;
